const _ = require('lib/underscore')
const Backbone = require('lib/backbone')
const BaseElement = require('./element.base')


const RadiosetElement = BaseElement.extend({

    validateConstructor(attrs) {
        if (! attrs.values) throw new Error('Radioset Element requires a list of values.')

        // inline require to allow circular dependency between Element & ElementList
        const ElementList = require('./element_list')

        // ensure that `values` is a ElementList
        if (attrs.values instanceof ElementList) return attrs

        // attempt to convert a Backbone.Collection or array to an ElementList
        if (attrs.values instanceof Backbone.Collection) {
            // convert Backbone.Collection to an array
            attrs.values = attrs.values.toJSON()
            // let next step convert it from an array to an ElementList
        }

        if (_.isArray(attrs.values)) {
            // have to set type to radio before converting to an ElementList
            // or Element creation will fail
            attrs.values.forEach(item => {
                item.type = 'radio'
            })
            attrs.values = new ElementList(attrs.values)
        }

        // if still not an ElementList, conversion failed, throw an error
        if (! (attrs.values instanceof ElementList)) {
            throw new Error('RadioSet Element requires a list of values.')
        }

        return attrs
    },

    initializeElement() {
        this.radios = this.get('values')

        this.setRadioNames()
        this.setCheckedRadio()

        this.listenTo(this.radios, 'change:checked', this.onRadioChangeChecked)
        this.listenTo(this, 'change:value', this.setCheckedRadio)
    },

    onRadioChangeChecked(model, checked, options) {
        if (checked) {
            this.set('value', model.get('value'))
        }
    },

    setRadioNames() {
        // set name of every radio element to this name
        this.radios.each((radio) => {
            radio.set({
                name: this.get('name'),
            })
        }, this)
    },

    setCheckedRadio() {
        const value = this.get('value')
        const checked = this.radios.findWhere({ checked: true })

        if (checked && checked.get('value') !== value) {
            checked.set('checked', false)
        }

        const same_value = this.radios.findWhere({ value })
        if (same_value) same_value.set('checked', true)
    },

})

module.exports = RadiosetElement
